/**
 * The beginning of where to host display preferences
 */
export const headerView = { showDetail: true };
